<div class="global-search-overlay">
  <ng-content></ng-content>
</div>
